import { useEffect, useRef, useState } from 'react';

const SCROLL_DELTA_THRESHOLD = 8;
const TOP_REVEAL_Y = 64;

/**
 * Hides the navbar while scrolling down and reveals it again on scroll-up.
 * Pauses while `suspend` is true (e.g. open menus).
 */
export function useNavScrollReveal({ enabled = true, suspend = false } = {}) {
    const [hidden, setHidden] = useState(false);
    const lastScrollY = useRef(0);

    useEffect(() => {
        if (!enabled) {
            setHidden(false);
            return undefined;
        }

        const onScroll = () => {
            if (suspend) {
                return;
            }

            const currentY = window.scrollY;
            const delta = currentY - lastScrollY.current;

            if (currentY <= TOP_REVEAL_Y) {
                setHidden(false);
            } else if (delta > SCROLL_DELTA_THRESHOLD) {
                setHidden(true);
            } else if (delta < -SCROLL_DELTA_THRESHOLD) {
                setHidden(false);
            }

            lastScrollY.current = currentY;
        };

        lastScrollY.current = window.scrollY;
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [enabled, suspend]);

    useEffect(() => {
        if (suspend) {
            setHidden(false);
        }
    }, [suspend]);

    return hidden;
}
